export const PixKeyTypeEnum = {
    CPF: "CPF",
    CNPJ: "CNPJ",
    EMAIL: "EMAIL",
    PHONE: "PHONE",
    RANDOM_KEY: "RANDOM_KEY",
};
